/**
 * Tiny string helpers shared by layout components.
 *
 * These exist so that templates like the copyright line and the title format
 * can live in a content module with the rest of the editable copy, instead of
 * being assembled from fragments inside a component.
 */

/** Replaces every `{key}` in `template` with the matching value. */
export function fillTemplate(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    const value = values[key];
    return value === undefined ? match : String(value);
  });
}
